import styles from './LoaderButton.module.scss';

interface LoaderButtonProps {
    classNameStyle?: string;
}


const LoaderButton: React.FC<LoaderButtonProps> = (props) => {

    return <div className={`${styles.loader} ${props.classNameStyle !== undefined ? styles[props.classNameStyle] : styles.white}`}></div>;
}


export default LoaderButton;
